"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const utilitycautionsm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 26 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-utilitycautionsm` : '') + (description ? ` desc-utilitycautionsm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-utilitycautionsm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-utilitycautionsm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.01 21a1.89 1.89 0 0 1-1.87-1.9c0-.3.06-.59.2-.85l8.12-15.2a1.86 1.86 0 0 1 3.35 0l8.13 15.2c.46.94.08 2.08-.84 2.55-.26.13-.55.2-.84.2H5.01Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 8.19c-.04-.39.18-.7.55-.7h1.15c.37 0 .6.31.58.7l-.1 5.38c-.04.35-.73.57-1.05.57-.32 0-.97-.22-1-.57l-.14-5.38Zm1.13 7.13c.65 0 1.13.48 1.13 1.1v.17c0 .62-.48 1.1-1.13 1.1a1.1 1.1 0 0 1-1.14-1.1v-.16c0-.63.5-1.11 1.14-1.11Z",
    fill: "#8F6600"
  }));
};
var _default = exports.default = utilitycautionsm;